// extracted by mini-css-extract-plugin
export default {"wrapper":"CloseWrapper_wrapper__qk80Q","wrapper__close":"CloseWrapper_wrapper__close__JpGoc"};